import React, { createContext, useEffect, useState, useContext } from "react";
import { isLocalPrinterReady } from "../../utils/prodlocalhelper";
import { t } from "i18next";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { connect } from "react-redux";

import MessageOkModal from "../modal/modalWindow/messageOkModal"
import ConfirmationModal from "../modal/modalWindow/confirmationModal"
 
const AppContext = createContext();

const useAppContext = () => useContext(AppContext);
const AppProvider = (props) =>{
    const [printerStatus, setPrinterStatus] = useState('idle');
    const [printerName, setPrinterName] = useState();

    const [showMessageModal, setShowMessageModal] = useState();
    const [messageModalConfig, setMessageModalConfig] = useState();

    const [showConfirmationModal, setShowConfirmationModal] = useState();
    const [confirmationModalConfig, setConfirmationModalConfig] = useState();

    useEffect(()=>{
        isLocalPrinterReady((err, res) => {
          if (err) {
            setPrinterStatus('ERROR')
            setPrinterName(t("dashboard_main.local_printer_not_ready"))
            console.log(err);
          } else {
            setPrinterStatus(res.data.status)
            setPrinterName(res.data.name)
          }
        });
      },[])

    const openMessageModal=(title, message)=>{
        setMessageModalConfig({title, message});
        setShowMessageModal(true);
    }

    const openConfirmationModal=(title, message, okCallback=()=>{}, cancelCallback=()=>{})=>{
      setConfirmationModalConfig({title, message, okCallback, cancelCallback});
      setShowConfirmationModal(true);
    }

    return (
        <AppContext.Provider value={{
            printerStatus:printerStatus,
            printerName:printerName,
            showMessage:openMessageModal,
            showConfirmationMessage:openConfirmationModal
        }}>
            {props.children}
            <MessageOkModal
                open={showMessageModal}
                title={messageModalConfig?.title}
                children={messageModalConfig?.message}
                button1Title={t('ok')}
                onConfirm={()=>{setShowMessageModal(false)}}
            />
            <ConfirmationModal
                open={showConfirmationModal}
                title={confirmationModalConfig?.title}
                children={confirmationModalConfig?.message}
                button1Title={t('ok')} 
                button2Title={t('cancel')} 
                onConfirm={()=>{
                  setShowConfirmationModal(false);
                  confirmationModalConfig.okCallback();
                }}
                onCancel={()=>{
                  setShowConfirmationModal(false);
                  confirmationModalConfig.cancelCallback();
                }}
            />
        </AppContext.Provider>
    );
}

export {useAppContext};

export default AppProvider;
